export interface NotificacaoPaginateResponse {
  _id: string;
  description: string;
  createdAt: number;
  actionTarget: ActionTargetNotificationEnum;
  action: string;
  type: SystemNotificationEnum;
  visualizedAt: number;
  title: string;
}

export enum SystemNotificationEnum {
  paymentDuplicated = "paymentDuplicated",
}

export enum ActionTargetNotificationEnum {
  internal = "internal",
  external = "external",
  copy = "copy",
}
